import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.unpackingView.finishedUnpackingDialog.title',
    defaultMessage: 'Finished unpacking',
    description: 'Title of the finished unpacking dialog',
  },
  message: {
    id: 'pages.unpackingView.finishedUnpackingDialog.message',
    defaultMessage:
      "You're done unpacking the parcels. You can now keep unpacking other shipments or start putting away the items you have unpacked.",
    description: 'Message of the finished unpacking dialog',
  },
  actions: {
    putAway: {
      id: 'actions.putAway',
      defaultMessage: 'Put away',
      description: 'Label of the put away action in the finished unpacking dialog',
    },
    keepUnpacking: {
      id: 'pages.unpackingView.finishedUnpackingDialog.actions.keepUnpacking',
      defaultMessage: 'Keep unpacking',
      description: 'Label of the keep unpacking action in the finished unpacking dialog',
    },
  },
  feedback: {
    putAwayFailed: {
      id: 'pages.unpackingView.finishedUnpackingDialog.feedback.putAwayFailed',
      defaultMessage: 'Items could not be put away',
      description: 'Error message of the put away action in the finished unpacking dialog',
    },
  },
};

export default defineMessages(translations);
